const formsNames = {
  login: "login",
  registration: "registration",
  recoverPassword: "recoverPassword",
  notification: "notification"
};

export default formsNames;



// WEBPACK FOOTER //
// ./src/constants/authorization.js